var Request;
var Categories;
var DocReady;

function viewInvoice(id) {
	flashLoading();
	jQuery('#Modal .modal-body').load('/dashboard/modal/invoice/'+id, function(r,s,x) {
		jQuery('#Modal').modal();
	});
}


function getStateList(e) {
	var el = jQuery(e).find('option:selected').val();
	var st = jQuery('select[name="state"]')
	
	st.parent().append('<i class="spinner fa fa-spin fa-spinner"></i>');	
	st.load('/api/states/'+el, function() {
		jQuery('.spinner').hide();
	});	
	
}

function getPlan(val, country) {
	jQuery('#MembershipInfo').html('<span class="fa fa-spinner fa-spin"></span> Loading...');
	jQuery('#TermsBox').hide();
	
	var country = jQuery('select[name="country"] option:selected').val();
	var str = '+ VAT';
	
	if(val != '0') {
		jQuery.getJSON('/api/plan/'+val+'/'+country, function(data) {
			
			if(data.currency == '&dollar;') {
				str = '';
			}


			jQuery('#MembershipInfo').html('<div class="Wrap"><div class="Image"><img src="'+ data.image + '" /></div><div class="Info"><h3>' + data.name + '</h3><div class="description">'+ data.short_description + '</div>' + '<div>'+data.currency + data.price + ' '+str+'</div></div></div>');
		}).success(function() {
			jQuery('#TermsBox').show();
			
		}).fail(function() {
			jQuery('#MembershipInfo').html('<label class="label label-danger">Sorry, there was an error processing this request.');
		});
		
	} else {
		jQuery('#TermsBox').hide();
		jQuery('#MembershipInfo').html('<em>Please select how many employees you have before continuing.</em>');
	}
}

function checkCoupon(button) {
		var CouponCode = jQuery('input[name="coupon"]').val();
		
		jQuery('.couponwaiting').show().html('<div class="label label-info">Checking Code</div>');
				
		jQuery.getJSON('/api/coupon/'+CouponCode, function(data) {
					if(data.status == 'ERR') {
						jQuery('.couponwaiting').html('<div class="label label-danger">'+data.message+'</div>');
						var ERR = 1;
					} else {
						jQuery('.couponwaiting').html('<div class="label label-success">'+data.message+'</div>');
						reloadPayment();
					}
		});
		
		/*.success(function() {
			//if(!ERR) {
				jQuery('.couponwaiting').hide();
				reloadPayment();
			//}
		});*/
}

function reloadPayment() {
	jQuery('#Payment').html('<i class="fa fa-spin fa-spinner"></i>');
	jQuery('#Content').load('/payment #Content');
}

function fileUpload(target) {
	jQuery(target).click();
}

function apiUpload(val, csrf) {
	
	var fd = new FormData(document.getElementById('fileinfo'));
   
	jQuery.ajax({
	    type: "POST",
		url: "/api/upload",
		headers: {'X-CSRF-TOKEN': csrf},
		contentType: false,
		processData: false,
		enctype: 'multipart/form-data',
		data: fd,
		beforeSend: function() {
			jQuery('.file-upload').html('<span class="fa fa-spin fa-spinner"></span> Uploading....');
		}
	}).success(function(data) {
		if(data[0].status == 'OK') {
			jQuery('.file-upload').html('<img src="'+ data[0].message + '" />');
		}
	});
}

function setCategory(id) {
	var Limit = jQuery('.category_select').data('category');
	var Link = jQuery('.cat_'+ id +' a.categorySelect');
	var Checkbox = jQuery('input[type="checkbox"][value="'+ id +'"]');
	Link.toggleClass('active');
	
	var Count = jQuery('.categorySelect.active').size();

	Checkbox.click();
	Link.find('span.additional').hide();
	
	if(Count > Limit) {
		if(Checkbox.is(':checked')) {
			Link.append('<span class="additional"> </span>');
			Link.addClass('additionalCat');
		}
	}
	
	if(Count == Limit) {
		jQuery('.additional').hide();
		jQuery('.active').removeClass('additionalCat');
	}	
}

function validateAbout() {
	var Limit = jQuery('.category_select').data('category');	
	var Categories = jQuery('.categorySelect.active').size();
	var Additional = jQuery('span.additional').size();
	var Errors = 0;
	
	jQuery('#AdditionalCats .count').html(Additional);
	
	jQuery('.required').each(function(e) {
		var Val = jQuery(this).val();
		if(Val.length == 0) {
			jQuery(this).addClass('error').parent().find('label').append('<span class="label label-danger">This field is required.</span>');
			Errors++;
		}
	});
	
	if(Categories > Limit) {
		jQuery('#AdditionalCats').modal();
	} else {
		if(Errors <= 0) {
			jQuery('.aAjaxForm').submit();
		}
	}
}

function validateForm(f) {
	var Errors = 0;
	jQuery('.required').each(function(e) {
		var Val = jQuery(this).val();
		
		if(Val.length == 0) {
			jQuery(this).addClass('error').parent().find('label').append('<span class="label label-danger">This field is required.</span>');
			Errors++;
		}
		
		if(jQuery(this).attr('name') == 'email') {
			var Val1 = jQuery(this);
			var Val2 = jQuery('input[name="email_2"]');
			
			if(Val2.val() != Val1.val()) {
				jQuery(Val2).addClass('error').parent().find('label').append('<span class="label label-danger">Email addresses do not match.</span>');
				Errors++;
			}
		}
		
		if(jQuery(this).attr('name') == 'password') {
			var Val1 = jQuery(this);
			var Val2 = jQuery('input[name="password_2"]');
			
			if(Val2.val() != Val1.val()) {
				jQuery(Val2).addClass('error').parent().find('label').append('<span class="label label-danger">Passwords do not match.</span>');
				Errors++;
			}
		}


		if(jQuery(this).attr('name') == 'postcode') {
			var Val = jQuery(this).val();

			if(Val.length > 10) {
				jQuery(this).addClass('error').parent().find('label').append('<span class="label label-danger">Post Code must be less than 10 Characters.</span>');
				Errors++;
			}
		}
	});
	
	if(jQuery('#tc').length > 0) {
		if(jQuery('#tc').is(':checked')) {
			jQuery('#tc').parent().find('label').css('color','#333333');
		} else {
			Errors++;
			jQuery('#tc').parent().find('label').css('color','#ff0000');
		}
	}

	if(jQuery('input[name="vat_number"]').val()) {
		Errors++;
		var vat_num = jQuery('input[name="vat_number"]');

		jQuery.get('api/check-vat-number/'+vat_num.val()).success(function(d) {
			if(d.status == 'ERR') {
				jQuery(vat_num).addClass('error').parent().find('label').append('<span class="label label-danger">VAT number is not correct.</span>')
				//Errors++
			} else {
				jQuery(vat_num).removeClass('error').parent().find('.label-danger').hide();
				Errors--;
				if(Errors == 0) {
					jQuery('#AjaxForm').submit();
				}
			}
		});
	}
	
	
	if(Errors > 0) {
		jQuery('.formError').html('<div class="label label-danger">Please check the form for errors.</div>');
	} else {
		jQuery('#AjaxForm').submit();
	}

} 

function changeBilling() {
	jQuery('.tog').toggleClass('hidden');
	jQuery('.tog input').toggleClass('required');
}

function planPrice(p, input) {
	var v = jQuery(p).val();
	
	jQuery.getJSON('/api/plan/'+v, function(data) {
		jQuery('input[name="'+input+'"]').val(data.price);
	});
	
}

function canPurchaseContract(f) {
	var Id = jQuery(f).data('id');
	jQuery.getJSON('/api/can-purchase/'+Id, function(data) {
		jQuery('#Modal .modal-body').html(data[0].message);
		modalShow();
	});
}

function purchaseContract(f) {
	jQuery(f).attr('disabled','disabled').html('<i class="fa fa-spin fa-spinner"></i>');
	var id = jQuery(f).data('id');
	jQuery.getJSON('/api/purchase/'+id, function(data) {
		jQuery('#Modal .modal-body').html(data.message);
	});
}

function staffModal(id) {
	flashLoading();
	jQuery('#Modal .modal-body').load('/api/staff/'+id, function(e) {
			jQuery('#Modal').modal();
	});
}

function testimonialModal(id) {
	flashLoading();
	jQuery('#Modal .modal-body').load('/api/testimonial/'+id, function(e) {
			jQuery('#Modal').modal();
	});
}

function portfolioModal() {
	flashLoading();
	jQuery('#Modal .modal-body').load('/api/portfilio', function(e) {
		modalShow();
	});
}

function updateProfileImage(location, height, width) {
	flashLoading();
	jQuery('#Modal .modal-body').load('/api/profile-image/'+location+'?height='+height+'&width='+width, function() {
		jQuery('#Modal').modal();
	});
}

function officeModal(id) {
	flashLoading();
	jQuery('#Modal .modal-body').load('/api/profile-office/'+id, function() {
		jQuery('#Modal').modal();
	});
}

function ajaxContractPurchase() {
	
}

function ajaxPayment() {
	var formData = jQuery('#ajaxPayment').serialize();	
	jQuery.ajax({
		url: '/api/payment',
		type: 'post',
		data: formData,
		dataType: 'json',
		beforeSend: function() {
			modalShow();
			modalLoading();
		}
	}).success(function(data) {
		jQuery('#Modal .modal-body').html(data.message);
	});
}

function threeDSecureReturn(token) {
	modalLoading();
	
	jQuery.getJSON('/api/confirm-payment/'+token, function(data) {
		jQuery('#Modal .modal-body').html(data.message);
	});
}

function modalShow() {
	jQuery('#Modal').modal({ keyboard: false, backdrop: 'static' });
}

function paymentError() {
	jQuery('#Modal .modal-body').html('<div class="big-label label-danger"><i class="fa fa-warning"></i> Sorry, there was a problem completing your payment.</div>');
}
function modalLoading() {
	jQuery('#Modal .modal-body').html('<div class="big-label label-warning"><i class="fa fa-spin fa-spinner"></i> Loading...</div>');
}

function prependLoading() {
	removePrepend();
	jQuery('#Modal .modal-body').prepend('<div class="big-label label-warning"><i class="fa fa-spin fa-spinner"></i> Loading...</div>');
	modalShow();
}

function prependError(string) {
	removePrepend();
	if(!string) {
		var String = 'There was an error processing your request.'
	} else {
		var String = string;
	}
	jQuery('#Modal .modal-body').prepend('<div class="big-label label-danger">'+ string +'</div>');
	modalShow();
}

function prependSuccess(string) {
	removePrepend();
	if(!string) {
		var String = 'Success!'
	} else {
		var String = string;
	}
	
	jQuery('#Modal .modal-body').prepend('<div class="big-label label-success">'+ string +'</div>');
	//jQuery('#Modal .modal-body .big-label').delay(1000).animate({opacity:0},1000).toggle('slow');
}

function prependWarning(string) {
	removePrepend();
	if(!string) {
		var String = 'Success!'
	} else {
		var String = string;
	}
	
	jQuery('#Modal .modal-body').prepend('<div class="big-label label-warning">'+ string +'</div>');
	//jQuery('#Modal .modal-body .big-label').delay(1000).animate({opacity:0},1000).toggle('slow');
}

function removePrepend() {
	jQuery('#Modal .modal-body .big-label').remove();
}

function submitPaymentForm(b) {
	var cType = jQuery('select[name="card_type"]').val();
	var cNum = jQuery('input[name="cardnumber"]').val();
	var cName = jQuery('input[name="cardname"]').val();
	var cExpire = jQuery('input[name="expiry"]').val();
	var cv2 = jQuery('input[name="cardcv2"]').val();
	
	jQuery.ajax({
		url: '/api/payment',
		type: 'post',
		data: { 'cardname': cName, 'cardnumber': cNum, 'card_type': cType, 'expiry': cExpire, 'cv2': cv2, 'plan': 1},
		beforeSend: function() {
			flashLoading();
			jQuery('#Modal .modal-body').html('<i class="fa fa-spin fa-spinner"></i>');
			modalShow();
		}
	}).success(function(data) {
			jQuery('#Modal .modal-body').html(data.message);
	});
}

function paymentComplete() {
	jQuery('#Modal .modal-body').html('<div class="big-label label-success"><i class="fa fa-check"></i> Payment Successful</div');
}

function repeatPayment(id) {
	modalLoading();
	jQuery.getJSON('/api/repeat-payment/'+id).success(function(d) {
		jQuery('#Modal .modal-body').html(d.message);
	});
}

function viewPortfolio(id) {
	flashLoading();
	jQuery('#Modal .modal-body').load('/portfolio/'+id, function(e) {
		modalShow();
	});
}

function ajaxForm() {
	jQuery('.AjaxForm').on('submit', function(e) {
		e.preventDefault();
		var action = this.action;		
		var fd = new FormData(this);
		var parent = this;
				
		jQuery.ajax({
			type: 'POST',
			url: action,
			data: fd,
			processData: false,
			contentType: false,
			beforeSend: prependLoading()
		}).success(function(d) {
			if(d.status == 'OK' || d.status == 'WRN') {				
				if(d.status == 'OK') {
					prependSuccess(d.message);
				}
				
				if(d.status == 'WRN') {
					jQuery('#Modal .modal-body').html('');
					prependWarning(d.message);
				}
				
				if(d.body) {
					jQuery('#Modal .modal-body').append(d.body);
				}
				
				if(d.replaceBody) {
					jQuery('#Modal .modal-body').html(d.body);
				}
				
				if(!jQuery(parent).hasClass('noModal')) {		
					parent.reset();
				}
				
			} else {
					prependError(d.message);
			}
			//jQuery('#Content').load(window.location.href + ' #Content');
		}).fail(function(d) {
			prependError('Sorry, there was a problem - If this persists, please call 020 3004 9644');
		});
	});
}

function editDescription() {
	flashLoading();
	jQuery('#Modal .modal-body').load('/api/edit-profile-description', function(e) {
			jQuery('#Modal').modal();
	});
}

function deleteStaff(id) {
	modalLoading();
	jQuery.getJSON('/api/delete-staff/'+id).success(function(d) {
		//jQuery('#Content').load(window.location.href + ' #Content');
		jQuery('[data-staff="'+id+'"]').toggle('slow');
		jQuery('#Modal').modal('hide');
	});
}

function deleteTestimonial(id) {
	modalLoading();
	jQuery.getJSON('/api/delete-testimonial/'+id).success(function(d) {
		//jQuery('#Content').load(window.location.href + ' #Content');
		jQuery('[data-testimonial="'+id+'"]').toggle('slow');
		jQuery('#Modal').modal('hide');
	});
}


function deleteOffice(id) {
	modalLoading();
	jQuery.getJSON('/api/delete-office/'+id).success(function(d) {
		jQuery('[data-office="'+id+'"]').toggle('slow');
		jQuery('#Modal').modal('hide');
	});
}

function deletePortfolio(id) {
	modalLoading();
	jQuery.getJSON('/api/delete-portfolio/'+id).success(function(d) {
		jQuery('[data-portfolio="'+id+'"]').toggle('slow');
		jQuery('#Modal').modal('hide');
	});
}

function confirmDelete(type, id) {
	flashLoading();	
	jQuery.getJSON('/api/confirm-delete/'+ type + '/' + id, function(d) {
		jQuery('#Modal .modal-body').html(d.message);
	}).success(function() {
		modalShow();
	});
}

function requiredFields() {
	if(DocReady !=1) {
		jQuery('.required').parent().find('label').remove('span').append('<span style="color: #ff0000"> *</span>');
	}
	DocReady=1;
}

function modalRequiredFields() {
        jQuery('#Modal .modal-body .required').parent().find('label').remove('span').append('<span style="color: #ff0000"> *</span>');
}


function imageResize_init() {
	jQuery('.previewImage').on('change', function() {
		jQuery('#imgPreview').append('<div id="Cropper"><img id="preview" /></div>');
		jQuery('.imgInstructions').show();
		if(this.files || this.files[0]) {
			var ratio = jQuery(this).data('aspect');
			var blob;
			var preview = jQuery('#preview');
			var dataHeight = jQuery(this).data('height');
			var dataWidth = jQuery(this).data('width');

			jQuery('#preview').css('min-height', dataHeight);

			blobURL = URL.createObjectURL(this.files[0]);
		
			preview.attr('src', blobURL);
			preview.cropper({ viewMode: 0, dragMode: 'move', cropBoxResizable: false, built: function() {preview.cropper("setCropBoxData", { width: dataWidth, height: dataHeight})}});
			preview.cropper('replace', blobURL);
			
			preview.on('crop.cropper', function(e) {
				getCropData();
			});
		}	
	});
}

function getCropData() {
	var cropper = jQuery('#preview');
	jQuery('input[name="imageParams"]').val(JSON.stringify(cropper.cropper('getData', true)));
}

function filterForm() {

}

function moreMedia() {
	jQuery('.mediaRow:first').clone().appendTo('#Media').find('input').val("");
}

function flashLoading() {
	jQuery('.Loading').remove();
	//jQuery('.Loading').css({display:'block', opacity:1}).delay(800).animate({opacity:0},1000);
	jQuery('#Content').prepend('<div class="big-label label-warning Loading"><i class="fa fa-spin fa-spinner"></i> Loading</div>');
	jQuery('.Loading').delay(800).animate({opacity:0},1000);
	setTimeout(function() {
		jQuery('.Loading').remove();
	},1800);
}

function flashSuccess() {
	jQuery('.Loading').remove();
	//jQuery('.Success').css({display:'block', opacity:1}).delay(1000).animate({opacity:0},1000);
	jQuery('#Content').prepend('<div class="big-label label-success Loading"><i class="fa fa-check"></i> Success</div>');
	jQuery('.Loading').delay(800).animate({opacity:0},1000);
	setTimeout(function() {
		jQuery('.Loading').remove();
	},1800);
}


function passwordConfirm() {
	var p1 = jQuery('input[name="password"]').val();
	var p2 = jQuery('input[name="password_2"]').val();
	
	if(p1 == p2) {
		return true;
	} else {
		return false;
	}
}

function termsModal() {
	flashLoading();
	jQuery('#Modal .modal-body').load('/pages/terms', function() {
		modalShow();
	});
}

function confirmApproval() {
	flashLoading();
	jQuery('#Modal .modal-body').load('/profile/approval', function() {
		modalShow();
	});
}

function requestApproval(csrf) {
	modalLoading();
	jQuery.ajax({
		type: 'POST',
		url: '/profile/approval',
		headers: {'X-CSRF-TOKEN': csrf}
	}).success(function(d) {
		if(d.status == 'OK') {
			jQuery('#Modal .modal-body').html(d.message);
		}
	});
}

function editProfile() {
	flashLoading();
	jQuery('#Modal .modal-body').load('/profile/edit', function() {
		modalShow();
	});
}

function editCoreService() {
	flashLoading();
	jQuery('#Modal .modal-body').load('/profile/edit-core', function() {
		modalShow();
	});
}

function forgotPassword() {
	jQuery('#Modal .modal-body').load('/reset', function() {
		modalShow();
	});
}

function toggleEdit(elem) {

	jQuery(elem).find('.edit').toggle();
}

function viewTestimonial(id) {
	jQuery('#Modal .modal-body').load('/api/view-testimonial/'+id, function() {
		modalShow();
	});
}

jQuery(document).ready(function() {
	ajaxForm();
	requiredFields();
	jQuery('.required').on('focusout change', function() {
		var Value = jQuery(this).val();
		
		if(Value.length == 0) {
			jQuery(this).addClass('error').parent().find('label').append('<span class="label label-danger">This field is required.</span>');
		} else {
			jQuery(this).parent().find('label span').hide();
			jQuery(this).removeClass('error');
		}
	});
	
	jQuery('input[name="password_2"]').keyup(function() {
		if(passwordConfirm()) {
			jQuery(this).removeClass('error');
		} else {
		selectSearch(jQuery(this).val());
		}
	});
	
	jQuery('.singleSearch').keyup(function() {
		singleSearch(jQuery(this));
	});
	
	jQuery('.sticky').stick_in_parent();
	jQuery('.hasTip').focus(function() {
		jQuery(this).parent().find('tip').toggle();
	});
	
	jQuery('.editable').click(function() {
		var Type = jQuery(this).data('type');
		var Position = jQuery(this).data('position');
		var height = jQuery(this).data('height');
		var width = jQuery(this).data('width');
		
		switch(Type) {
			case 'image':
				updateProfileImage(Position, height, width);
			break;
		}
		
	});
	
	jQuery('#Header div.label-success').delay(1500).animate({
		'opacity': 0
	},3000);

	jQuery('#Modal').on('shown.bs.modal', function(e) {
		ajaxForm();
		modalRequiredFields();
		imageResize_init();
	});
	
	jQuery('#Modal').on('hidden.bs.modal', function() {
		jQuery('#Modal .modal-body').html('');
	});
	
	jQuery('#Filter').on('change', function() {
		var data = jQuery(this).serialize();
		
		jQuery('#ops').load('/api/filter?'+data + ' #ops');
		jQuery('#Reset').show();
	});

	jQuery('.inlineEdit').click(function() {
		jQuery(this).parent().find('.hiddenEdit').show();
	});
	
	jQuery('.showEdit').click(function() {
		jQuery('.hiddenEdit').show();
	});
	
	jQuery('a.modalLink').click(function(e) {
		e.preventDefault();
		var el = jQuery(this);
		var href = el.attr('href');
		
		jQuery('#Modal .modal-body').load(href, function() {
			modalShow();
		});
		
	});

	/*jQuery(document).ajaxError(function() {
		prependError('Sorry, there was a problem processing your request.')
	});*/

});
